export default __webpack_public_path__ + "locales/sl/DeleteDialog.json?hash=044446269881c4d83cd8dcecf0dbc3ee";